module.exports = __webpack_public_path__ + "static/media/samppa-kaataa.c58e85d1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/samppa-kaataa.jpg
 ** module id = 401
 ** module chunks = 0
 **/